import React, { Component } from 'react';
import styled from 'styled-components';

import withi18n from '../../../utils/withI18n';
import { getLabel } from '../../../utils/i18n';
import Regrex from '../../../utils/regrex';
import FlexBox from '../../FlexBox';
import { formatDate } from '../../../utils/datetime';

const Container = styled(FlexBox)`
  font-size: 14px;
  margin: 40px 70px;
  width: 100%;

  &:not(:first-child) {
    border-top: 1px solid #f6f6f6;
    padding-top: 43px;
    margin: 20px 70px;
  }

  a {
    text-decoration: none;
  }

  .date {
    margin-right: 14px;
    font-size: 16px;
    color: #333;
    line-height: 28px;
    flex: 0.75;

    > div {
      border-right: 1px solid #e6e6e6;
      padding-right: 9px;
    }
  }

  .content {
    flex: 9;

    .title {
      color: #333;
      font-size: 24px;
      line-height: 31px;
      margin-bottom: 20px;
      font-weight: bold;

      a {
        color: #333;

        &:hover {
          color: #f0b90b;
        }
      }
    }

    .first-img {
      display: block;
      margin-bottom: 24px;

      > img {
        width: 740px;
        max-width: initial !important;
      }
    }

    .desc {
      color: #666;
      font-size: 16px;
      line-height: 26px;

      &.detail {
        color: initial;
      }

      img {
        max-width: 100%;
        height: auto;
      }

      > p {
        flex: 1;
      }
    }

    .more-opt {
      margin-top: 20px;

      .read-btn {
        color: #f0b90b;
        border: 1px solid #f0b90b;
        padding: 5px 10.3px;
        border-radius: 3px;

        a {
          color: #f0b90b;
        }

        &:hover {
          background: #f0b90b;

          a {
            color: #fff;
          }
        }
      }
    }
  }
`;

const stripHtml = (html) => {
  let texts = html.replace(/<!--[\s\S]*?-->/mg, '')
    .replace(/(&nbsp;|\n)/img, '')
    .replace(/<\/?.+?>/mg, '');

  if (texts.length >= 300) {
    texts = `${texts.substr(0, 300)}...`;
  }
  return texts;
};

const getFirstImg = html => html.match(/<img.*?>/);
const formatLink = title => encodeURI(title.replace(Regrex.punctuation, '').replace(/ /g, '-'));

type Props = {
  isDetail: boolean,
  info: Object,
  locale: string,
  i18n: Object,
};

export default
@withi18n('blog')
class SingleBlog extends Component<Props> {
  static defaultProps = {
    isDetail: false,
    info: {},
  };

  getListContent() {
    const {
      info, locale, i18n,
    } = this.props;
    const {
      idStr, banner, brief, content, title = '',
    } = info;
    const link = `/${locale}/blog/${idStr}/${formatLink(title)}`;
    const result = [];
    if (brief) {
      result.push(<FlexBox key="brief" direction="column" className="desc">{brief}</FlexBox>);
      if (banner) {
        try {
          const bannerObj = JSON.parse(banner);
          const BannerContent = (
            <FlexBox
              key="img"
              className="first-img"
              dangerouslySetInnerHTML={{ __html: `<img src='${bannerObj.bannerUrl}'>` }}
            />
          );
          bannerObj.bannerLocation === 'above' ?
            result.unshift(BannerContent)
            :
            result.push(BannerContent);
        } catch (e) {
          // do nothing
        }
      }
    } else {
      getFirstImg(content) &&
        result.push(<FlexBox
          key="img"
          className="first-img"
          dangerouslySetInnerHTML={{ __html: getFirstImg(content)[0] }}
        />);
      result.push(
        <FlexBox
          key="brief"
          direction="column"
          className="desc"
        >
          {stripHtml(content)}
        </FlexBox>
      );
    }

    const ReadMoreContent = (
      <FlexBox className="more-opt" key="readmore">
        <FlexBox className="read-btn">
          <a href={link}>{getLabel('exchange-blog-blog-readmore', i18n, 'Read More')}</a>
        </FlexBox>
      </FlexBox>
    );

    result.push(ReadMoreContent);

    return result;
  }

  render() {
    const {
      isDetail, info, locale,
    } = this.props;
    const {
      idStr, title = '', content, postTime, createTime,
    } = info;
    const link = `/${locale}/blog/${idStr}/${formatLink(title)}`;

    return (
      <Container direction="row">
        <FlexBox direction="column" className="date">
          <FlexBox>{formatDate(postTime || createTime, 'y', locale)}</FlexBox>
          <FlexBox>{formatDate(postTime || createTime, 'm', locale)}</FlexBox>
        </FlexBox>

        <FlexBox className="content" direction="column">
          <FlexBox className="title">
            {
              isDetail ?
                <span>{title}</span> :
                <a href={link}>{title}</a>
            }
          </FlexBox>

          {
            isDetail ? (
              <FlexBox
                direction="column"
                className="desc detail"
                dangerouslySetInnerHTML={{ __html: content }}
              />
            ) :
              this.getListContent()
          }
        </FlexBox>
      </Container>
    );
  }
}
